import {useEffect, useState} from 'react';
import { Outlet } from 'react-router-dom';

import Header from './Header';
import Footer from '../Footer';
import {useDispatch, useSelector} from "react-redux";
import {handlerResetStore} from "../../store/reducer/reset_store";
import {Auth} from "aws-amplify";
import {Tooltip} from "@mui/material";
import IconButton from "../../Components/@extended/IconButton";
import {LogoutOutlined} from "@ant-design/icons";
import React from "react";
import Snackbar from "../../Components/@extended/Snackbar";
import {getAuthPlan} from "../../store/reducer/authuser"
import {
    getSubscriptions,
    handlerSetXeroTenant,
    handlerSetSubscriptionSelect,
    handlerSetXeroConnectionsList,
    getUsersList
} from "../../store/reducer/xero_connection";
import {handlerResetPayables} from "../../store/reducer/payables";
import Loader from "../../Components/Loader";
import {openSnackbar} from "../../store/reducer/snackbar";
import useOAuth2 from "../../OAuth2/OAuth2";

function LogoutButton(props){
    const dispatch = useDispatch();
    const handleLogOut = () => {
        dispatch(handlerResetStore({}));
        Auth.signOut()
    }

    return (

        <Tooltip title="Logout">
            <IconButton size="large" sx={{ color: 'text.primary' }} onClick={handleLogOut}>
                <LogoutOutlined />
            </IconButton>
        </Tooltip>

    )
}

const MainLayout = () => {
    const dispatch = useDispatch();
    const { username } = useSelector( (state) => state.authuser)
    const [loading, setLoading] = useState(true);
    const {subscription_list, error_xero_connection, xero_tenant} = useSelector((state) => state.xeroconnection);
    const { data, loading_xero, error, getAuth } = useOAuth2({
        authorizeUrl: "https://login.xero.com/identity/connect/authorize",
        clientId: process.env.REACT_APP_CLIENT_ID,
        // redirectUri: `${document.location.origin}/callback`,
        redirectUri: process.env.REACT_APP_redirectSignIn + `callback`,
          scope: "offline_access openid profile email accounting.invoices accounting.payments accounting.banktransactions accounting.manualjournals accounting.settings.read accounting.reports.read payroll.employees.read payroll.payruns.read payroll.payslip.read payroll.timesheets.read accounting.contacts",
        responseType: "code",
      });

    useEffect(() => {
        console.log("In Main Layout")
        // No longer required as in backend will continuously refresh tokens.
        // if (Date(parseInt(xero_tenant['exp']) * 1000 + 1800000) <= Date()) {
        //   console.log("reset state")
        //   dispatch(handlerSetXeroTenant({
        //     xero_tenant: {}
        //   }))
        //   dispatch(handlerSetSubscriptionSelect({
        //     selected_subscription: null
        //   }));
        //   //     Set kanban state to initial state.
        // }
        if (JSON.stringify(subscription_list) == "[]"){
            const get_subscriptions_list = dispatch(getSubscriptions(username));
            Promise.all([get_subscriptions_list]).then(() => setLoading(false));
        }
        if (error_xero_connection && JSON.stringify(xero_tenant) == "{}"){
            dispatch(openSnackbar({
                      open: true,
                      message: error_xero_connection.data.data,
                      anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
                      variant: 'alert',
                      alert: {
                        color: 'success'
                      },
                      close: false
                    }))
            setLoading(false);
        }
        if (JSON.stringify(xero_tenant)!='{}'){
          // if (!('defaultValue' in data.data)){
              console.log("Got");
              const result = JSON.parse(JSON.stringify(xero_tenant));
              console.log(result);
              dispatch(handlerSetXeroTenant({
                xero_tenant:result
              }));
              dispatch(handlerSetXeroConnectionsList({
                  connections_list: result.connections_list
              }))
            setLoading(false);
              return function clear_local_storage(){
                  localStorage.removeItem(process.env.REACT_APP_OAUTH_STATE_KEY);
              }
          }
    }, [data])
    // if (username != ''){
    //     const planName = dispatch(getAuthPlan(username));
    //     Promise.all([planName]).then((values => console.log(values)));
    //     if (loading) return <Loader />;
    //     if (error) {
    //         return <div>Error</div>;
    //         }
    //     if (loading_xero) {
    //       return <Loader />;
    //     }
    //     }
        // if (loading) return <Loader />;
        // if (error) {
        //     return <div>Error</div>;
        //     }
        // if (loading_xero) {
        //   return <Loader />;
        // }
    return (
        <>
            <Header LogoutButton={LogoutButton} handlerSetSubscriptionSelect={handlerSetSubscriptionSelect} getUsersList={getUsersList} getSubscriptions={getSubscriptions} handlerResetPayables={handlerResetPayables}/>
            <Snackbar />
            <Outlet />
            <Footer />
        </>
    )
}

export default MainLayout;